<template>
  <sui-accordion exclusive styled>
    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat2aLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat2aContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat2bLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat2bContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat2cLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat2cContent')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat2dLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat2dContent1')" />
      <p v-html="$t('cat2dContent2')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat2eLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat2eContent1')" />
    </sui-accordion-content>

    <sui-accordion-title>
      <sui-icon name="dropdown" />
      {{ $t('cat2fLabel') }}
    </sui-accordion-title>
    <sui-accordion-content>
      <p v-html="$t('cat2fContent1')" />
      <p v-html="$t('cat2fContent2')" />
    </sui-accordion-content>

  </sui-accordion>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }</script>

<style lang="scss" scoped>
</style>
